import React, { useState } from 'react';
import { toast } from 'sonner';
import { CheckCircle2, ExternalLink, HelpCircle, Pencil, XCircle } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { fmtDate } from '../../lib/dates';

const ST = {
  verificado: ['text-emerald-300', CheckCircle2, 'Artículo verificado en el texto vigente'],
  norma_verificada: ['text-emerald-300', CheckCircle2, 'Norma verificada en LeyChile'],
  articulo_no_encontrado: ['text-amber-300', HelpCircle, 'Norma verificada; el artículo no se encontró en el texto vigente'],
  fallo_consulta: ['text-rose-300', XCircle, 'Falló la consulta a LeyChile'],
};

// One legal basis: label + article, LeyChile link and the real verification result with the article's opening words for human review
export const LegalRef = ({ r }) => {
  const v = r.verificacion;
  const [cls, Icon, txt] = ST[v?.status] || ['text-slate-500', HelpCircle, 'Sin verificar aún'];
  return (
    <div className="text-xs">
      <span className="text-slate-200">{r.label}{r.art ? `, art. ${r.art}` : ''}</span>
      {v?.url && <a href={v.url} target="_blank" rel="noreferrer" className="ml-2 inline-flex items-center gap-0.5 text-sky-300 hover:underline">LeyChile<ExternalLink className="h-3 w-3" /></a>}
      <p className={`flex items-center gap-1 ${cls}`}><Icon className="h-3 w-3 shrink-0" />{txt}{v?.checked_at ? ` · ${fmtDate(v.checked_at, true)}` : ''}{v?.error ? ` · ${v.error}` : ''}</p>
      {v?.extracto && <p className="text-slate-500">«{v.extracto}…»</p>}
    </div>
  );
};

export const CatalogEdit = ({ kind, item, field, onDone }) => {
  const { api } = useAuth();
  const [open, setOpen] = useState(false);
  const [val, setVal] = useState(item[field] || '');
  const [note, setNote] = useState('');
  const save = async () => {
    try { await api.put(`/legal-catalog/${kind}/${item.id}`, { fields: { [field]: val }, note }); toast.success('Corrección guardada con tu nombre y fecha'); setOpen(false); onDone(); } catch (e) { toast.error(e?.response?.data?.detail || 'No se pudo guardar'); }
  };
  if (!open) return <button data-testid={`catalog-edit-${item.id}`} onClick={() => setOpen(true)} className="rounded p-1 text-slate-500 hover:text-amber-300"><Pencil className="h-3.5 w-3.5" /></button>;
  return (
    <div className="mt-2 flex w-full flex-col gap-2">
      <textarea data-testid={`catalog-edit-value-${item.id}`} value={val} onChange={(e) => setVal(e.target.value)} rows={3} className="w-full rounded-lg border border-slate-700 bg-slate-950 p-2 text-xs" />
      <input data-testid={`catalog-edit-note-${item.id}`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Motivo o fuente de la corrección" className="w-full rounded-lg border border-slate-700 bg-slate-950 px-2 py-1 text-xs" />
      <div className="flex gap-2"><button data-testid={`catalog-edit-save-${item.id}`} onClick={save} className="rounded bg-amber-500 px-3 py-1 text-xs font-semibold text-slate-950">Guardar</button><button onClick={() => setOpen(false)} className="text-xs text-slate-400">Cancelar</button></div>
    </div>
  );
};
